import type { ApplicationConfigurationDto } from '@unistocks/proxy/axios-client';
import { useApplicationConfiguration } from '@unistocks/shared/hooks/use-application-configuration';

const selectGoogleClientId = ({ extraProperties }: ApplicationConfigurationDto) =>
  extraProperties['externalAuthentication']['google']['clientId'];

export const useGoogleClientId = () =>
  useApplicationConfiguration({ select: selectGoogleClientId });
